module.exports = __webpack_public_path__ + "img/reminders.49adaaca.png";